/* unplugin-vue-components disabled */import script from "./RoleCapabilityEditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCapabilityEditCard.vue?vue&type=script&setup=true&lang=js"

import "./RoleCapabilityEditCard.vue?vue&type=style&index=0&id=4e37da91&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e37da91"]])

export default __exports__